import React from "react";

export class CookiePolicyFR extends React.Component {
    render() {
        return (
            <>
                <p>
                    Dernière mise à jour: <b>28/11/2024</b>
                    <br />
                    <br />
                </p>
                <p>
                    Ce document a été préparé conformément au Règlement UE 2016/679 (le « RGPD ») pour permettre aux utilisateurs de comprendre quels cookies sont installés
                    lorsqu’ils utilisent un portail DeepUnity PACSonWEB (le "Site Web").
                </p>
                <h2>1. Responsable du traitement et délégué à la protection des données</h2>
                <p>
                    DH Healthcare GmbH, dont le siège social est situé Konrad-Zuse-Platz 1-3, 53227 Bonn, Germany, est le responsable du traitement des données personnelles (les
                    données) des utilisateurs du site Web collectées à l’aide de cookies. Pour toute demande, il est possible d’écrire à DH Healthcare GmbH à l’adresse physique
                    susmentionnée ou via l’adresse e-mail.
                    <br />
                    DH Healthcare GmbH a nommé un délégué à la protection des données (“DPO”), qui peut être contacté à Dpo.belgium@dedalus.eu
                </p>
                <h2>2. Données traitées par DH Healthcare GmbH</h2>
                <p>
                    Lanavigation sur les sites Web implique l’utilisation de cookies, de courtes chaînes de texte que les sites Web visités envoient au navigateur de l’utilisateur,
                    où elles sont stockées puis transmises aux mêmes sites Web lors de visites ultérieures. Lors de la navigation sur un site, l’utilisateur peut également recevoir
                    des cookies sur sonordinateur provenant de sites ou de serveurs Web autres que celui qu’il visite (cookies dits « tiers »). Il est possible de distinguer :
                    <br />
                    <br />
                    a. les cookies techniques, qui permettent d’effectuer des activités liées au fonctionnement du Site.
                    <br />
                    <br />
                    b. Cookies de profilage, utilisés pour analyser le comportement de l’utilisateur et, si nécessaire, pour envoyer des messages publicitaires en ligne avec les
                    préférences exprimées par l’utilisateur lors de la navigation.
                    <br />
                    <br />
                    c. Le stockage local, qui permet d'effectuer des activités liées au fonctionnement du site.
                </p>
                <p>
                    <br />
                    Ce site Web utilise les cookies suivants:
                </p>
                <h3>a) Techniques de cookies</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Hôte</th>
                            <th>Catégorie</th>
                            <th>Descripción</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>.ASPXAUTH</td>
                            <td>Dobco</td>
                            <td>Nécessaire</td>
                            <td>Authentification du portail DeepUnity PACSonWEB.</td>
                        </tr>
                        <tr>
                            <td>ASP.NET_SessionId</td>
                            <td>Dobco</td>
                            <td>Nécessaire</td>
                            <td>ID de sesión del portal DeepUnity PACSonWEB</td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedNecessaryCookies</td>
                            <td>Dobco</td>
                            <td>Nécessaire</td>
                            <td>Ce cookie est défini si vous choisissez d’autoriser tous les cookies et registres lorsqu’il a été défini.</td>
                        </tr>
                        <tr>
                            <td>.AspNetCore.Culture </td>
                            <td>Dobco</td>
                            <td>Nécessaire</td>
                            <td>Enregistre le choix de langue dès qu’il est modifié manuellement.</td>
                        </tr>
                        <tr>
                            <td>POWLanguage</td>
                            <td>Dobco</td>
                            <td>Nécessaire</td>
                            <td>Enregistre le choix de la langue dès qu'il est modifié manuellement (la langue du navigateur est utilisée comme norme).</td>
                        </tr>
                        <tr>
                            <td>RETURNSCU</td>
                            <td>Dobco</td>
                            <td>Nécessaire</td>
                            <td>Le portail client sur lequel vous vous êtes connecté.</td>
                        </tr>
                        <tr>
                            <td>Dobco.LocalImageCaches</td>
                            <td>Dobco</td>
                            <td>Nécessaire</td>
                            <td>Enregistre les caches d'images locaux, liés à l'utilisateur.</td>
                        </tr>
                        <tr>
                            <td>Dobco.ExternalLogin</td>
                            <td>Dobco</td>
                            <td>Nécessaire</td>
                            <td>Il est utilisé pour sauvegarder l'état d'une connexion externe lors d'un aller-retour. Cela est nécessaire pour des raisons de sécurité afin de prévenir les attaques CSRF et les attaques par rejeu. Le cookie est chiffré.</td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedAllCookies </td>
                            <td>Dobco</td>
                            <td>Fonctionnel</td>
                            <td>Ce cookie est défini si vous choisissez d’autoriser tous les cookies et registres lorsqu’il a été défini.</td>
                        </tr>
                    </tbody>
                </table>
                <h3>b) Cookies analytiques/de profilage</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Hôte</th>
                            <th>Durée</th>
                            <th>Catégorie</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>_GA</td>
                            <td>Google</td>
                            <td>2 ans</td>
                            <td>Analytique</td>
                            <td>Utilisé pour distinguer les utilisateurs.</td>
                        </tr>
                        <tr>
                            <td>_GID</td>
                            <td>Google</td>
                            <td>24 heures</td>
                            <td>Analytique</td>
                            <td>Utilisé pour distinguer les utilisateurs.</td>
                        </tr>
                        <tr>
                            <td>_GA_&lt;container_id&gt;</td>
                            <td>Google</td>
                            <td>2 ans</td>
                            <td>Analytique</td>
                            <td>Utilisé pour conserver l'état de la session.</td>
                        </tr>
                    </tbody>
                </table>
                <h3>c) Stockage local (Hôte: Dobco ; Catégorie: Nécessaire)</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>cookie-shownNews</td>
                            <td> la dernière fois que vous avez ouvert les avis</td>
                        </tr>
                        <tr>
                            <td>POWHomerBGuid</td>
                            <td> ID pour l'utilisation de HomeReading</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3StudyTutorial</td>
                            <td>enregistre si le didacticiel a déjà été montré</td>
                        </tr>
                        <tr>
                            <td>POW3SharingOtherDestinationSettings</td>
                            <td> paramètres préférés pour le partage d'une étude</td>
                        </tr>
                        <tr>
                            <td>printing_check_openByDefault</td>
                            <td> paramètre préféré pour l'impression d'une enquête</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3LoginSource</td>
                            <td> le portail client sur lequel vous vous êtes connecté</td>
                        </tr>
                        <tr>
                            <td>cookie-acceptedPOW3Cookies</td>
                            <td> indique si la politique en matière de cookies a déjà été affichée</td>
                        </tr>
                        <tr>
                            <td>ShownImportNews</td>
                            <td>l'enregistrement des faits d'actualité importants déjà présentés</td>
                        </tr>
                        <tr>
                            <td>Reportfontsize</td>
                            <td> taille de la police du rapport dans le visualiseur</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3LoginOption</td>
                            <td> votre mode de connexion (patient / médecin)</td>
                        </tr>
                        <tr>
                            <td>cookie-uniqueBrowserIdentifier</td>
                            <td>
                                Identifie de manière unique votre navigateur au sein de DeepUnity PACSonWEB. Il est utilisé pour déterminer s'il vous est demandé de saisir un OTP
                                lors de la connexion ou non.
                            </td>
                        </tr>
                        <tr>
                            <td>cookie-last-audio-out-volume</td>
                            <td> Sauvegarde le dernier niveau de volume audio utilisé</td>
                        </tr>
                        <tr>
                            <td>cookie-PreferredRecognitionLanguage</td>
                            <td> Enregistre votre langue de reconnaissance vocale préférée.</td>
                        </tr>
                        <tr>
                            <td>cookie-scalingFactorConfiguration</td>
                            <td>Enregistre votre facteur d'échelle préféré et la résolution de départ correspondante.</td>
                        </tr>
                        <tr>
                            <td>cookie-dontShowPopupForNewsIds</td>
                            <td>Identifie les fenêtres contextuelles d'actualités que vous ne souhaitez plus voir apparaître.</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    Bien que les cookies techniques nécessaires ne puissent pas être refusés par l’utilisateur du site Web, car ils sont strictement fonctionnels pour le site Web
                    lui-même, l’utilisateur peut librement choisir d’accepter ou de refuser l’utilisation de cookies analytiques, de profilage et non strictement nécessaires.
                    L’utilisateur peut définir et consulter ses choix concernant les cookies avec la fonction “Modifier les paramètres des cookies” disponible sur le site Web
                    (section “Juridique“)
                </p>
                <h2>3. Finalités et base juridique dutraitement</h2>
                <p>
                    En utilisantdes cookies, les objectifs suivants sont poursuivis:
                    <br />
                    <br />
                    3.1 Pour permettre la navigation sur le siteWeb et son bon fonctionnement. La base juridique du traitement est la fourniture aux utilisateurs de services liés à
                    Website et l’intérêt légitime de Dedalus à disposer d’un site Web fonctionnel.
                    <br />
                    <br />
                    3.2 Pour remplir toute obligation en vertu des lois, réglementations ou législations de l’UE applicables, ou pour se conformer aux demandes des autorités. La
                    base juridique du traitement est l’obligation de Dedalus de se conformer à la législation obligatoire.
                    <br />
                    <br />
                    3.3 Analyser le comportement de l’utilisateur et éventuellement lui envoyer des messages publicitaires en ligne avec les préférences exprimées par celui-ci lors
                    de la navigation. La base juridique du traitement dans ce cas est le consentement de la partie intéressée.
                    <br />
                    <br />
                    3.4 Pour les besoins de la défense des droits de Dedalus dans le cadre de tout litige, même en justice. La base juridique du traitement est l’intérêt légitime
                    du propriétaire à protéger ses droits.
                    <br />
                    <br />
                    L’attribution de données est facultative, mais (sauf en cas de traitement basé sur le consentement) le défaut de fournir des données empêche le
                    contrôleurd’autoriser la navigation sur le Web.
                </p>
                <h2>4. Destinataires des Données</h2>
                <p>
                    Les Données peuvent être communiquées :
                    <br />
                    <br />
                    (a) à des tiers qui ont besoin d’effectuer des activités spécifiques en relation avec les Données, conformément aux finalités du traitement, ou à des
                    prestataires de services au Responsable du traitement.
                    <br />
                    <br />
                    (b) aux autorités, entités et/ou parties auxquelles les Données doivent être divulguées, conformément à des dispositions légales ou contractuelles
                    contraignantes.
                    <br />
                    <br />
                    (c) dans d’autres circonstances, telles que des acquisitions et des ventes à des sociétés tierces potentielles, lorsque nous prévoyons de vendre ou de
                    transférer tout ou partie de notre activité.
                </p>
                <h2>5. Transfert de données en dehors del’Espace économique européen</h2>
                <p>
                    En ce qui concerne le transfert éventuel de données vers des pays n’appartenant pas à l’Espace économique européen, le traitement aura lieu selon l’une des
                    méthodes légalement autorisées et donc par la sélection de destinataires établis dans des pays considérés comme adéquats par la Commission européenne ou par la
                    stipulation de clauses contractuelles types.
                </p>
                <h2>6. Conservation des données</h2>
                <p>
                    Les Données ne seront conservées que pendant le temps nécessaire aux finalités pour lesquelles elles ont été collectées, dans le respect des principes de
                    limitation et de minimisation de la conservation. Plus précisément, les modalités de durée des cookies sont définies dans la section 2 précédente. Pour les
                    Données dont le traitement est basé sur le consentement de l’intéressé, il est précisé qu’elles seront conservées jusqu’à ce que ce consentement soit révoqué.
                </p>
                <h2>7. Droits des personnes concernées</h2>
                <p>
                    En présence des prérequis juridiques pertinents, la personne concernée peut demander au Responsable du traitement ou au DPO l’accès à ses Données, les rectifier
                    ou les effacer ou s’opposer à leur traitement, demander la limitation du traitement dans les cas prévus à l’article 18 du RGPD, ainsi que les obtenir de manière
                    structurée, mettre en forme couramment utilisée et lisible par machine les données le concernant, dans les cas prévus à l’article 20 du RGPD.
                    <br />
                    <br />
                    En outre, l’utilisateur a le droit de révoquer tout consentement au traitement à tout moment, sans affecter la licéité du traitement effectué par le responsable
                    du traitement avant la révocation.
                    <br />
                    <br />
                    Les demandes doivent être adressées par écrit au responsable du traitement aux adresses indiquées ci-dessus.
                    <br />
                    Dans tous les cas, l’intéressé peut déposer une plainte auprès du Garant pour la protection des données personnelles s’il estime que le traitement de ses
                    données est contraire à la réglementation en vigueur.
                </p>
            </>
        );
    }
}
